import PropTypes from "prop-types";
import { useEffect, useMemo } from "react";
import FlightsFilterSort from "./FlightsFilterSort.jsx";
import {
	flightsFilterValuesShape,
	quotationFlightShape,
	quotationPropTypes,
} from "app/utils/propTypes";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { bindActionCreators } from "redux";
import {
	checkShowFlightFilters,
	getAirlinesFilterValues,
	getArrivalAirportFilterValues,
	getCabinFilterValues,
	getDepartureAirportFilterValues,
	getFiltersCount,
	getInboundDurationsFilterValues,
	getInboundTakeOffTimeFilterValues,
	getIncludedFlight,
	getLuggageFilterValues,
	getMinUpgradePricesGroupByCabin,
	getOutboundDurationsFilterValues,
	getOutboundTakeOffTimeFilterValues,
	getStopCountFilterValues,
	getUpgradePriceFilterValues,
} from "app/pages/Booking/Quotation/quotationSelectors";
import isEmpty from "lodash/isEmpty";
import {
	resetFlightsFilter,
	resetFlightsPageSize,
	setFlightsFilterBy,
} from "app/pages/Booking/Quotation/quotationActionCreators";
import { hasTrainTransportation } from "app/pages/Listing/productsSelector";
import withRouter from "app/utils/hocs/withRouter";

const FlightsFilterSortContainer = ownProps => {
	const stateProps = useSelector(state => mapStateToProps(state, ownProps), shallowEqual);
	const dispatch = useDispatch();
	const dispatchProps = useMemo(() => mapDispatchToProps(dispatch), [dispatch]);
	const props = { ...ownProps, ...stateProps, ...dispatchProps };

	useEffect(() => {
		let flightsFilterBy = {};

		if (
			(props.quotation.filterFlightsBy.inboundDuration?.min === undefined ||
				props.quotation.filterFlightsBy.inboundDuration?.max === undefined) &&
			props.filterValues.inboundDuration?.min !== undefined &&
			props.filterValues.inboundDuration?.max !== undefined
		) {
			flightsFilterBy.inboundDuration = {
				min: props.filterValues.inboundDuration.min,
				max: props.filterValues.inboundDuration.max,
			};
		}

		if (
			(props.quotation.filterFlightsBy.outboundDuration?.min === undefined ||
				props.quotation.filterFlightsBy.outboundDuration?.max === undefined) &&
			props.filterValues.outboundDuration?.min !== undefined &&
			props.filterValues.outboundDuration?.max !== undefined
		) {
			flightsFilterBy.outboundDuration = {
				min: props.filterValues.outboundDuration.min,
				max: props.filterValues.outboundDuration.max,
			};
		}

		if (
			(props.quotation.filterFlightsBy.inboundTakeOffTime?.min === undefined ||
				props.quotation.filterFlightsBy.inboundTakeOffTime?.max === undefined) &&
			props.filterValues.inboundTakeOffTime?.min !== undefined &&
			props.filterValues.inboundTakeOffTime?.max !== undefined
		) {
			flightsFilterBy.inboundTakeOffTime = {
				min: props.filterValues.inboundTakeOffTime.min,
				max: props.filterValues.inboundTakeOffTime.max,
			};
		}

		if (
			(props.quotation.filterFlightsBy.outboundTakeOffTime?.min === undefined ||
				props.quotation.filterFlightsBy.outboundTakeOffTime?.max === undefined) &&
			props.filterValues.outboundTakeOffTime?.min !== undefined &&
			props.filterValues.outboundTakeOffTime?.max !== undefined
		) {
			flightsFilterBy.outboundTakeOffTime = {
				min: props.filterValues.outboundTakeOffTime.min,
				max: props.filterValues.outboundTakeOffTime.max,
			};
		}

		if (
			props.quotation.filterFlightsBy.upgradePrice === undefined &&
			props.filterValues.upgradePrice !== undefined
		) {
			flightsFilterBy.upgradePrice = props.filterValues.upgradePrice;
		}

		if (
			props.quotation.filterFlightsBy.cabin === undefined &&
			props.filterValues.cabin !== undefined &&
			props.filterValues.cabin[0] !== undefined
		) {
			flightsFilterBy.cabin = props.includedFlight?.outbound?.cabin; // sélection par défaut de la classe du vol qui est inclus
		}

		// TODO Eviter un dispatch inutile en faisant une comparaison deep entre this.props.filterValues et nextProps.filterValues
		if (!isEmpty(flightsFilterBy)) {
			props.setFlightsFilterBy(flightsFilterBy);
		}
	}, [
		props.filterValues,
		props.quotation.filterFlightsBy,
		props.setFlightsFilterBy,
		props.includedFlight,
	]);

	return <FlightsFilterSort {...props} />;
};

FlightsFilterSortContainer.propTypes = {
	quotation: quotationPropTypes,
	filterValues: flightsFilterValuesShape,
	setFlightsFilterBy: PropTypes.func,
	resetFlightsFilter: PropTypes.func,
	resetFlightsPageSize: PropTypes.func,
	includedFlight: quotationFlightShape,
	filtersCount: PropTypes.number,
};

const mapStateToProps = (state, ownProps) => {
	const isStopOver = ownProps.location?.pathname?.includes("/stopover");
	return {
		filtersCount: getFiltersCount(state),
		includedFlight: getIncludedFlight(state),
		quotation: state.quotation,
		currencyCode: state?.currency,
		travelByTrainAvailable: hasTrainTransportation(state),
		filterValues: {
			stopsCount: getStopCountFilterValues(state),
			departureAirport: getDepartureAirportFilterValues(state),
			arrivalAirport: getArrivalAirportFilterValues(state),
			cabin: getCabinFilterValues(state),
			airline: getAirlinesFilterValues(state),
			outboundDuration: getOutboundDurationsFilterValues(state),
			inboundDuration: getInboundDurationsFilterValues(state),
			inboundTakeOffTime: getInboundTakeOffTimeFilterValues(state),
			outboundTakeOffTime: getOutboundTakeOffTimeFilterValues(state),
			upgradePrice: getUpgradePriceFilterValues(state),
			luggage: getLuggageFilterValues(state),
		},
		minUpgradePricesByCabin: getMinUpgradePricesGroupByCabin(state),
		shouldShowFlightFilters: checkShowFlightFilters(state) && !isStopOver,
		shop: state.shop,
		brand: state.brand.code,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{ setFlightsFilterBy, resetFlightsFilter, resetFlightsPageSize },
		dispatch
	);
};

export default withRouter(FlightsFilterSortContainer);
